import { EventPopover } from "./EventPopover";
import { checkIfOneDayEvent } from "./helper";

export const renderEventContent = ({
  eventInfo,
  isSmallScreen,
  onChange,
  selectedEvent,
  setSelectedEvent,
}: any) => {
  const { event } = eventInfo?.event.extendedProps || {};
  const {
    event_setting_attributes: {
      starts_at: startsAt,
      ends_at: endsAt,
      time_zone: timeZone,
    },
  } = event || {};

  const isOneDayEvent = checkIfOneDayEvent({ startsAt, endsAt, timeZone });

  if (isSmallScreen) {
    return <span className="mx-0.5 h-1 w-1 rounded-full bg-gray-400" />;
  }
  return (
    <EventPopover
      isOneDayEvent={isOneDayEvent}
      onChange={onChange}
      eventInfo={eventInfo}
      event={event}
      selectedEvent={selectedEvent}
      setSelectedEvent={setSelectedEvent}
    />
  );
};
